<h1 matDialogTitle>{{ 'Sign CSR' | translate }}</h1>
<form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
  <ix-select
    formControlName="csr_cert_id"
    [label]="'CSRs' | translate"
    [options]="csrs$"
    [required]="true"
    [tooltip]="helptext.sign.csr_cert_id.tooltip | translate"
  ></ix-select>

  <ix-input
    formControlName="name"
    [label]="'Identifier' | translate"
    [required]="true"
    [tooltip]="helptext.sign.name.tooltip | translate"
  ></ix-input>

  <ix-form-actions>
    <button mat-button type="button" ixTest="cancel" matDialogClose>
      {{ 'Cancel' | translate }}
    </button>

    <button
      mat-button
      type="submit"
      color="primary"
      ixTest="sign-csr"
      [disabled]="form.invalid"
    >
      {{ 'Sign' | translate }}
    </button>
  </ix-form-actions>
</form>
